(function () {
    'use strict';

    function internalContentPhaseInformationPartConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/internalContentPhaseInformationPartConfiguration.html',
            link: function (scope) {
            }
        };
    }

    internalContentPhaseInformationPartConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('internalContentPhaseInformationPartConfiguration', internalContentPhaseInformationPartConfiguration);
})();

